// extracted by mini-css-extract-plugin
export default {"mainTitle":"base-mainTitle-efc5"};